import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import { Container, Row, Col, Table } from "react-bootstrap";


function Main(props) {
    
    const [activeIndex, setActiveIndex] = useState(props.activeIndex);

    const handleToggle = (index) => {
       
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    

   

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Faculty Recruitment" />
            <section className="project-detail">
                <div className="container">
                    <div className="c-heading">
                        <h1>Faculty Recruitment</h1>
                    </div>

                    <Row>
                        <div
                            className="col-lg-12 col-md-12  wow fadeInUp animated"
                            data-animation="fadeInUp"
                            data-delay=".4s"
                        >
                            <div
                                className="faq-wrap pl-30 wow fadeInUp animated"
                                data-animation="fadeInUp"
                                data-delay=".4s"
                            >
                                <div
                                    className="accordion"
                                    id="accordionExample"
                                >


                                   



                                    {/* Index11 ---------------------- start */}

                                    <div className="card">
                                        <div className="card-header">
                                            <h2 className="mb-0">
                                                <button
                                                    className={`faq-btn${activeIndex === 2 ? '' : ' collapsed'}`}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse11`}
                                                    onClick={() =>
                                                        handleToggle(11)
                                                    }
                                                >
                                                    
                                                        <h3> Faculty Recruitment Drive 2024 </h3>
                                                        <h4> Advertisement No. IITT/FACREC/01/2024 Dated January 24, 2024</h4>
                                                    
                                                </button>
                                            </h2>
                                        </div>
                                        <div
                                            id={`collapse11`}
                                            className={`collapse${activeIndex === 2 ? ' show' : ''}`} 
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="card-body">

                                                <b>
                                                    IIT Tirupati, an Institute of national importance declared as such under the Institute of Technology Act, 1961, invites applications from qualified Indian nationals, including Persons of Indian Origin (PIOs) and Overseas Citizens of India (OCIs) for faculty positions at the levels of Assistant Professor, Associate Professor, and Professor in the Departments and research areas as indicated below:
                                                </b>

                                                <ul className="myulcustarrow mt-3">
                                                   
                                                    <li>
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/recruitment/faculty/2024/Detailed_%20Advertisement-FacRec_01_2024.pdf"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">Detailed Advertisement</b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            to="https://recruitment.iittp.ac.in/"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">
                                                                Apply Online (Online application is closed)
                                                            </b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <b>
                                                            Starting Date of Online Application - 24.01.2024
                                                        </b>
                                                    </li>
                                                    <li>
                                                        <b>
                                                            Closing Date of Online Application - 29.02.2024
                                                        </b>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Index11 ---------------------- End  */}


                                    
                                   
                                   
                                  
                                    
                                    
                                </div>
                                <h5>
                                    <Link
                                        to="https://files.iittp.ac.in/pdfs/general/recordretentionschedule.pdf"
                                        target="_blank"
                                    >
                                        <b className="c-link">Retention of recruitment records</b>
                                    </Link>
                                </h5>
                            </div>
                        </div>
                    </Row>
                </div>
            </section>
        </>
    );
}

export default Main;
